import { render, staticRenderFns } from "./ExpressOrderCreation.vue?vue&type=template&id=1bc49196&scoped=true"
import script from "./ExpressOrderCreation.vue?vue&type=script&lang=js"
export * from "./ExpressOrderCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc49196",
  null
  
)

export default component.exports